import React, { useContext, useState } from 'react'
import classNames from 'classnames'
import ImageViewer from './imageViewer'
import { ArticleCardContext } from 'Components/ugc/article-card'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { processUrlWith_tplv_noop } from 'lib/optimize-image'
import applyHttpsImg from 'lib/apply-https-img'
export interface ImageItem {
  uri: string
  url: string
  width: number
  height: number
}

interface IProps {
  list: ImageItem[] | null
}

const compareFunc = (prevProps: IProps, nextProps: IProps) =>
  (prevProps.list?.length === nextProps.list?.length &&
    prevProps.list?.every(
      (e, index) => e.url === nextProps.list?.[index].url
    )) ||
  false

export default React.memo(({ list }: IProps) => {
  if (!list) return null
  const { inheritNewCard, group_id } = useContext(ArticleCardContext)
  const [isViewing, setViewing] = useState(false)
  const [activeIndex, setActiveIndex] = useState(0)
  const onClick = () => {
    setViewing(false)
  }

  return (
    <div className="ugc-image-list">
      {isViewing ? (
        <div className="image-viewer-wrapper">
          <ImageViewer
            imgList={list.map(e =>
              applyHttpsImg(
                e.uri ? processUrlWith_tplv_noop(e.uri, 1000) : e.url
              )
            )}
            activeIndex={activeIndex}
            onClick={onClick}
          />
        </div>
      ) : (
        list.slice(0, 4).map((e, index) => {
          return (
            <div
              key={index}
              className={classNames('ugc-image-item', {
                'has-more': list.length > 4 && index === 3,
              })}
              style={{
                backgroundImage: `url(${applyHttpsImg(
                  e.uri ? processUrlWith_tplv_noop(e.uri, 1000) : e.url
                )})`,
                cursor: 'zoom-in',
              }}
              onClick={(e: React.MouseEvent) => {
                e.preventDefault()
                e.stopPropagation()
                inheritNewCard &&
                  sendTeaCommEvent('click_motor_forum_feed_pic', {
                    group_id,
                  })
                setViewing(true)
                setActiveIndex(index)
              }}
            />
          )
        })
      )}

      <style jsx>
        {`
          .ugc-image-list {
            display: flex;
            justify-content: flex-start;
            margin: 8px 0;
          }
          .image-viewer-wrapper{
            width: 100%;
          }
          .ugc-image-item {
            width: calc((100% - 24px) / 4);  
            margin-right: 8px;
            height: 152px;
            background-size: cover;
            background-position: center center;
            background-color: white;
            cursor: pointer;
          }
          .ugc-image-item:last-child {
            margin-right: 0;
          }
          .has-more{
            position: relative;
          }
          .has-more::before{
            content: '';
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            position: absolute;
            background-color: rgba(0, 0, 0, 0.5);
          }
          .has-more::after {
            content: '+${list.length - 4}';
            width: 22px;
            height: 25px;
            top: 50%;
            left: 50%;
            position: absolute;
            transform: translate(-50%, -50%);
            color: white;
            font-size: 18px;
          }
        `}
      </style>
    </div>
  )
}, compareFunc)
